var CategoryAPI = require('../../common/api/category');
var UserAPI = require('../../common/api/user');
var ApplicationsAPI = require('../../common/api/application');
var _ = require('underscore');


module.exports = function ($scope, $location) {
  var vm = this;

  vm.applications = [];

  vm.pageSize = 6;
  vm.pageNumber = 1;
  vm.searching = false;
  vm.numberOfPages = 0;

  vm.searchPreferences = {
    searchText: "",
    radius: "",
    searchArea: "",
    categories: null,
    searchSort: "Relevance",
    amountRemaining: null,
    remainingExpression: "",
    percentRemaining: null,
    percentExpression: ""
  };

  vm.load = function () {
    CategoryAPI.GetTopLevelCategories().then(function (results) {
      vm.categories = results.map(function (c) {
        // convert this return value into the kind of object that
        // the search preferences API expects
        c.areaId = c.id;
        c.areaName = c.ccName;
        c.parentAreaId = c.ccParent;
        c.parentAreaName = null;
        delete c.id;
        delete c.ccName;
        delete c.ccParent;
        return c;
      });
    }).then(function() {
      UserAPI.GetSearchPreferences().then(function (result) {
        if (result) {
          vm.searchPreferences = result;

          // at this point, searchPreferences.categories will contain
          // objects which look the same as those in vm.categories -
          // change them to be references to the ACTUAL objects in
          // vm.categories
          vm.searchPreferences.categories = vm.searchPreferences.categories.map(function(c) {
            // find matching category in vm.categories
            // and return it
            var match = _.find(vm.categories, function(ac) { return ac.areaId == c.areaId; });
            return match;
          });
        }
        return vm.search();
      });
    });
  }

  vm.pageChange = function(next, prev){
    vm.pageNumber = next;
    vm.search();
  }

  vm.searchChanged = function () {
    vm.pageNumber = 1;
    vm.search();
  };

  vm.save = function () {
    UserAPI.UpdateSearchPreferences(vm.searchPreferences).then(function () {
      return vm.load();
    });
    vm.search();
  }

  function searchCallback(result) {
    vm.applications = result.results;
    vm.totalApplications = result.totalResults;

    if (vm.applications && vm.totalApplications) {
      vm.numberOfPages = Math.ceil(vm.totalApplications / vm.pageSize);

      vm.applications.forEach(function (app) {
        app.percentage = 0;
        if (!app.grandTotalRaised && !app.totalRequested && !app.totalExternallyRaised) {
          return;
        }

        app.percentage = Math.floor((app.grandTotalRaised / (app.totalRequested + app.totalExternallyRaised)) * 100);
        if (app.percentage > 100) {
          app.percentage = 100;
        }
      })
    }
  };

  vm.search = function () {
    vm.applications = [];
    vm.searching = true;
    var query = angular.copy(vm.searchPreferences);
    query.pageNumber = vm.pageNumber;
    query.pageSize = vm.pageSize;
    var catIds = [];
    if(query.categories) {
      query.categories.forEach( function(item) {
        catIds.push(item.areaId);
      })
      catIds = catIds.join(",")
    }
    return ApplicationsAPI.Search(query.searchText, 0, query.radius, catIds, query.searchArea, query.searchSort,  query.pageSize, query.pageNumber).then(searchCallback)
      .finally(function () {
        vm.searching = false;
      });
  }

  vm.load();
}
